import React from "react";
import withRipple from 'jd-library/withRipple';
import ImageLoader from '../../../common/Image/ImageLazyWrapper';
import { staticImageDomains } from '../../../../config/config';
import { getHighlightString } from "../../../utills";
import style from "./add-item.scss";
import styles from "./prod-list.scss";
import { NO_IMAGE_WITH_CAPTION, NO_IMAGE } from "jd-library/src/constants/ImageIcons";

export const ProdList = withRipple(props => {
    let { item, onClick, isLast } = props;
    let imageSrc = null;
    let imgClass = ""
    if(item.imagePath){
        let imagePath = item.imagePath;
        if(imagePath.includes(',')){
            imagePath = imagePath.split(',')[0];
        }
        let baseUrl = item.isTemplate || item.isTempProd ? staticImageDomains[3] + '/' : staticImageDomains[0] + '/product'; 
        imageSrc = imagePath.includes('http') ? imagePath + "?output-quality=80" : baseUrl + imagePath + "?output-quality=80";
    }else if(props.showNoImage){

        imageSrc = NO_IMAGE_WITH_CAPTION
        imgClass+= ' empty-image '
    }
    const imageLoaderProps = {
        finalImageSrc: imageSrc,
        loadOrignal: true,
        retainRandomColor: false,
        imgClass: imgClass
    };
    let contentPerPc = (item.contentPerPiece ? Number(item.contentPerPiece) : '');
    return (
        <div className={styles['prod-container'] + ' ' + props.rippleClass}
            onClick={e => setTimeout(() => {onClick(item) }, 300)}
            {...props.rippleHandler}>
            <div className={styles['left-sec']}>
                <ImageLoader
                    {...imageLoaderProps}
                />
            </div>
            <div className={styles['right-sec']}>
                <div className={styles['prod-name']}>{item.productTemplateName}</div>
                <div className={styles['prod-uom']}>{contentPerPc + ' ' + item.unitPerPiece}</div>
                {!isLast && <div className={styles['divider']}></div>}
            </div>
            {props.renderRipple()}
        </div>
    );
});

const highlighttext = (item, searchKey) => {
    return getHighlightString({
        searchKey: searchKey,
        searchResult: item.productTemplateName,
        className: styles["search-highlight"]
    });
};

export const ProdResultList = withRipple(props => {
    const { index, item, searchKey, itemData } = props;
    const image = {
        height: '1.75rem',
        width: '1.75rem',
        borderRadius: '4px',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
    let imageSrc = null;
    let imgClass = 'add-item-img';
    if(item.imagePath){
        let imagePath = item.imagePath;
        if(imagePath.includes(',')){
            imagePath = imagePath.split(',')[0];
        }
        let baseUrl = item.isTemplate || item.isTempProd ? staticImageDomains[3] + '/' : staticImageDomains[0] + '/product'; 
        imageSrc = imagePath.includes('http') ? imagePath + "?output-quality=80" : baseUrl + imagePath + "?output-quality=80";
    }else if(props.showNoImage){
        imageSrc = NO_IMAGE
        imgClass+= ' empty-image '
    }
    const imageLoaderProps = {
        finalImageSrc: imageSrc,
        loadOrignal: true,
        retainRandomColor: true,
        imgClass: imgClass,
        smallImage:true
    };

    return (
        <>
            <div key={index} className={style["category-block"] + ' ' + props.rippleClass}
                onClick={e => setTimeout(() => { itemData.onItemClick(item) }, 300)}
                {...props.rippleHandler}
            >
                <div className={style["left-side"]}>
                    {item.id ? (
                        <div style={image}>
                            <ImageLoader
                                {...imageLoaderProps}
                            />
                        </div>
                    ) : (
                            <i className={`${style["btn-style"]} ${itemData.icon}`}></i>
                        )}
                </div>

                <div
                    className={style["right-side"]}>
                    {item.id ? (
                        <span
                            dangerouslySetInnerHTML={{ __html: highlighttext(item, searchKey) }}
                        />
                    ) : (
                            <>
                                <span className={style["text-style"]}>{searchKey}</span>
                                <span className={style["child-text"]}>
                                    in{" "}
                                    <span className={style["text-blue"]}>
                                        {item.catName}
                                    </span>
                                </span>
                            </>
                        )}
                </div>
                {props.renderRipple()}
            </div>
            <div className={style["list-divider"]}></div>
        </>
    );
});

export const HeaderTitle = withRipple(props => {
    const { onHeaderIconClick, itemCategory } = props;
    return (
        < div className={style["flex-center"] + ' ' + props.rippleClass}
            onClick={e=>setTimeout(() => { onHeaderIconClick() }, 300)}
            {...props.rippleHandler}>
            <span>{itemCategory}</span>
            <i className={`${style["icon-right"]} icon-pagination-down`} />
            {props.renderRipple()}
        </div >
    );
});